import { render, staticRenderFns } from "./DisableResizeTextarea.vue?vue&type=template&id=2d3829dd"
import script from "./DisableResizeTextarea.vue?vue&type=script&lang=js"
export * from "./DisableResizeTextarea.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports